<template>
  <canvas v-if="canvasVisible" ref="canvas"></canvas>
</template>
  

<script>
export default {
  props: {
    isDarkMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      STAR_COLOR: '#fff',
      STAR_SIZE: 3,
      STAR_MIN_SCALE: 0.2,
      OVERFLOW_THRESHOLD: 50,
      STAR_COUNT: (window.innerWidth + window.innerHeight) / 18,
      scale: 1,
      width: 0,
      height: 0,
      stars: [],
      pointerX: null,
      pointerY: null,
      velocity: { x: 0, y: 0, tx: 0, ty: 0, z: 0.0005 },
      touchInput: false,

      context: null,
      canvasVisible: true,
    };
  },
  methods: {
    generate() {
      for (let i = 0; i < this.STAR_COUNT; i++) {
        this.stars.push({
          x: 0,
          y: 0,
          z: this.STAR_MIN_SCALE + Math.random() * (1 - this.STAR_MIN_SCALE),
        });
      }
    },

    placeStar(star) {
      star.x = Math.random() * this.width;
      star.y = Math.random() * this.height;
    },

    recycleStar(star) {
      let direction = 'z';
      let vx = Math.abs(this.velocity.x),
        vy = Math.abs(this.velocity.y);

      if (vx > 1 || vy > 1) {
        let axis;

        if (vx > vy) {
          axis = Math.random() < vx / (vx + vy) ? 'h' : 'v';
        } else {
          axis = Math.random() < vy / (vx + vy) ? 'v' : 'h';
        }

        if (axis === 'h') {
          direction = this.velocity.x > 0 ? 'l' : 'r';
        } else {
          direction = this.velocity.y > 0 ? 't' : 'b';
        }
      }

      star.z = this.STAR_MIN_SCALE + Math.random() * (1 - this.STAR_MIN_SCALE);

      if (direction === 'z') {
        star.z = 0.1;
        star.x = Math.random() * this.width;
        star.y = Math.random() * this.height;
      } else if (direction === 'l') {
        star.x = -this.OVERFLOW_THRESHOLD;
        star.y = this.height * Math.random();
      } else if (direction === 'r') {
        star.x = this.width + this.OVERFLOW_THRESHOLD;
        star.y = this.height * Math.random();
      } else if (direction === 't') {
        star.x = this.width * Math.random();
        star.y = -this.OVERFLOW_THRESHOLD;
      } else if (direction === 'b') {
        star.x = this.width * Math.random();
        star.y = this.height + this.OVERFLOW_THRESHOLD;
      }
    },

    // Old One
    resize() {
        this.scale = window.devicePixelRatio || 1;
        this.width = window.innerWidth * this.scale;
        this.height = window.innerHeight * this.scale;
        // console.log('Canvas Size:', this.width, this.height);
        const canvas = this.$refs.canvas;
        if (canvas) {
            canvas.width = this.width;
            canvas.height = this.height;
            this.stars.forEach(this.placeStar);
        }
    },

    step() {
        // console.log('Step function called');
        if (this.context) {
            this.context.clearRect(0, 0, this.width, this.height);
            this.update();
            this.render();
            requestAnimationFrame(this.step);
        } else {
            // Retry on the next animation frame if the context is not yet available
            requestAnimationFrame(this.step);
        }
    },

    //no animation
    update() {
      if (window.innerWidth < 768) {
        // Skip updating star positions on scroll for mobile devices
        return;
      }

      this.velocity.tx *= 0.96;
      this.velocity.ty *= 0.96;
      this.velocity.x += (this.velocity.tx - this.velocity.x) * 0.8;
      this.velocity.y += (this.velocity.ty - this.velocity.y) * 0.8;

      this.stars.forEach((star) => {
        star.x += this.velocity.x * star.z;
        star.y += this.velocity.y * star.z;
        star.x += (star.x - this.width / 2) * this.velocity.z * star.z;
        star.y += (star.y - this.height / 2) * this.velocity.z * star.z;
        star.z += this.velocity.z;

        if (
          star.x < -this.OVERFLOW_THRESHOLD ||
          star.x > this.width + this.OVERFLOW_THRESHOLD ||
          star.y < -this.OVERFLOW_THRESHOLD ||
          star.y > this.height + this.OVERFLOW_THRESHOLD
        ) {
          this.recycleStar(star);
        }
      });
    },

    // Star dosent move but continues with the zoom animation
    // update() {
    //   this.velocity.tx *= 0.96;
    //   this.velocity.ty *= 0.96;

    //   // Skip interaction-related updates for mobile devices
    //   if (window.innerWidth >= 768) {
    //     this.velocity.x += (this.velocity.tx - this.velocity.x) * 0.8;
    //     this.velocity.y += (this.velocity.ty - this.velocity.y) * 0.8;
    //   }

    //   this.stars.forEach((star) => {
    //     star.x += this.velocity.x * star.z;
    //     star.y += this.velocity.y * star.z;
    //     star.x += (star.x - this.width / 2) * this.velocity.z * star.z;
    //     star.y += (star.y - this.height / 2) * this.velocity.z * star.z;
    //     star.z += this.velocity.z;

    //     if (
    //       star.x < -this.OVERFLOW_THRESHOLD ||
    //       star.x > this.width + this.OVERFLOW_THRESHOLD ||
    //       star.y < -this.OVERFLOW_THRESHOLD ||
    //       star.y > this.height + this.OVERFLOW_THRESHOLD
    //     ) {
    //       this.recycleStar(star);
    //     }
    //   });
    // },


    render() {
      const context = this.$refs.canvas.getContext("2d");

      if (context) {
        // Set background color based on theme
        context.fillStyle = this.isDarkMode ? "black" : "white";
        context.fillRect(0, 0, this.width, this.height);

        context.globalAlpha = 1; // Set a constant alpha value for all stars

        // Set star color based on theme
        const starColor = this.isDarkMode ? "white" : "black";

        this.stars.forEach((star) => {
          context.beginPath();
          context.lineCap = "round";
          context.lineWidth = this.STAR_SIZE * star.z * this.scale;
          context.strokeStyle = starColor;
          context.moveTo(star.x, star.y);

          var tailX = this.velocity.x * 2,
            tailY = this.velocity.y * 2;

          if (Math.abs(tailX) < 0.1) tailX = 0.5;
          if (Math.abs(tailY) < 0.1) tailY = 0.5;

          context.lineTo(star.x + tailX, star.y + tailY);
          context.stroke();
        });
      }
    },


    // Disable the mouse tracker
    movePointer(x, y) {
      if (typeof this.pointerX === 'number' && typeof this.pointerY === 'number') {
        let ox = x - this.pointerX,
          oy = y - this.pointerY;
        this.velocity.tx = this.velocity.tx + (ox / 8 * this.scale) * (this.touchInput ? 1 : -1);
        this.velocity.ty = this.velocity.ty + (oy / 8 * this.scale) * (this.touchInput ? 1 : -1);
      }
      this.pointerX = x;
      this.pointerY = y;
    },

    onMouseMove(event) {
      this.touchInput = false;
      this.movePointer(event.clientX, event.clientY);
    },

    onTouchMove(event) {
      this.touchInput = true;
      this.movePointer(event.touches[0].clientX, event.touches[0].clientY, true);
      event.preventDefault();
    },
    // Disable the mouse tracker

    onMouseLeave() {
      this.pointerX = null;
      this.pointerY = null;
    },

    handleContextMenu(event) {
        // Prevent the default behavior of the contextmenu event
        event.preventDefault();
    },

    beforeDestroy() {
        // For example, remove event listeners
        this.$refs.canvas.removeEventListener('contextmenu', this.handleContextMenu);
    }
  },

  //Old one
  // mounted() {
  //   this.generate();
  //   this.resize();
  //   this.$nextTick(() => {
  //   this.context = this.$refs.canvas.getContext('2d');
  //   this.step();
  //     window.addEventListener('resize', this.resize);
  //     this.$refs.canvas.addEventListener('mousemove', this.onMouseMove);
  //     this.$refs.canvas.addEventListener('touchmove', this.onTouchMove);
  //     this.$refs.canvas.addEventListener('touchend', this.onMouseLeave);
  //     document.addEventListener('mouseleave', this.onMouseLeave);
  //   });
  //   this.$refs.canvas.addEventListener('contextmenu', this.handleContextMenu);
  // },

  // New one  
  mounted() {
    this.generate();
    this.resize();
    this.$nextTick(() => {
      this.context = this.$refs.canvas.getContext('2d');
      this.step();
      window.addEventListener('resize', this.resize);
      this.$refs.canvas.addEventListener('mousemove', this.onMouseMove);
      this.$refs.canvas.addEventListener('touchmove', this.onTouchMove);
      this.$refs.canvas.addEventListener('touchend', this.onMouseLeave);
      document.addEventListener('mouseleave', this.onMouseLeave);
    });
    this.$refs.canvas.addEventListener('contextmenu', this.handleContextMenu);
  },

  beforeDestroy() {
    this.$refs.canvas.removeEventListener('contextmenu', this.handleContextMenu);
    window.removeEventListener('resize', this.resize);
  },

};
</script>

<style lang="scss" scoped>
    body {
        width: 100%;
        height: 100vh;
        background: white;
    }

    canvas {
        position: fixed;
        width: 100%;
        height: 100%;
    }

</style>